import z from 'zod/v4'
import { sendScheduleKeys } from './schedule.ts'

export const feedbackSendingMethodSchema = z.union([z.literal('email'), z.literal('sms')])

export type FeedbackSendingMethod = z.infer<typeof feedbackSendingMethodSchema>

export const feedbackSettingsSchema = z.object({
  defaultSendingMethod: feedbackSendingMethodSchema
    .default('sms')
    .optional()
    .describe('Default sending method for feedback requests.'),
  defaultSendTiming: sendScheduleKeys
    .default('now')
    .optional()
    .describe(
      'Default send timing for feedback requests when using SMS. This is relative to when the feedback request was created.'
    ),
})

export type FeedbackSettings = z.infer<typeof feedbackSettingsSchema>

export const defaultFeedbackSettings = {
  defaultSendingMethod: 'sms',
  defaultSendTiming: 'now',
} as const

export type FeedbackDefaultsType = z.infer<typeof feedbackSettingsSchema>
